import React from 'react';

export default function Roadmap() {
  const roadmapData = [
    {
      phase: "Phase 1",
      title: " Foundation Launch",
      subtitle: "Platform Activation & Community Building",
      items: [
        "AGN platform launch",
        "User registration & onboarding system",
        "Passive and active income models activation",
        "Community and network expansion"
      ],
      highlight: "Establishing the AGN ecosystem foundation"
    },
    {
      phase: "Phase 2",
      title: "Global Expansion",
      subtitle: "Network Growth & International Reach",
      items: [
        "Expansion into multiple countries",
        "Global community development",
        "Leadership and reward programs launch",
        "International travel reward activation"
      ],
      highlight: "Strengthening worldwide participation"
    },
    {
      phase: "Phase 3",
      title: "Travel Platform Integration",
      subtitle: "Real-World Utility Services",
      items: [
        "Hotel booking services",
        "Flight & travel package integrations",
        "Travel-based reward ecosystem",
        "Affiliate & commission revenue model"
      ],
      highlight: " Adding real business utility to the ecosystem"
    },
    {
      phase: "Phase 4",
      title: "Blockchain Integration",
      subtitle: "Secure & Transparent Infrastructure",
      items: [
        "Blockchain-based transaction system",
        "Smart contract integration",
        "Digital wallet connectivity",
        "Enhanced security and transparency"
      ],
      highlight: "Building trust through decentralized technology"
    },
    {
      phase: "Phase 5",
      title: "NFT Marketplace Launch",
      subtitle: "Digital Asset Ecosystem",
      items: [
        "Launch of AGN NFT marketplace",
        "Utility-based digital collectibles",
        "NFT ownership & trading features",
        "Community engagement through digital assets"
      ],
      highlight: " Expanding into the digital economy"
    },
    {
      phase: "Phase 6",
      title: "Utility Services Expansion",
      subtitle: "Daily Use Digital Services",
      introText: "Future services may include:",
      items: [
        "Digital payment solutions",
        "E-commerce integrations",
        "Subscription-based services",
        "Financial and utility tools"
      ],
      highlight: " Creating an all-in-one ecosystem experience"
    },
    {
      phase: "Phase 7",
      title: "Future Vision",
      subtitle: "Global Digital Ecosystem",
      introText: "AGN aims to evolve into:",
      items: [
        "A global community-driven platform",
        "A blockchain-enabled ecosystem",
        "A utility-powered digital network",
        "A future-ready financial platform"
      ],
      highlight: "Connecting finance, technology, and lifestyle rewards"
    }
  ];

  return (
    <div className="agn-roadmap-wrapper">
      <style>{`
        .agn-roadmap-wrapper {
          padding: 80px 0;
          background: #f8f9fa;
          position: relative;
          overflow: hidden;
          font-family: var(--font-primary, sans-serif);
        }

        .roadmap-header {
          text-align: center;
          margin-bottom: 60px;
        }

        .roadmap-header h2 {
          font-size: 2.5rem;
          font-weight: 800;
          color: #111;
          margin-bottom: 15px;
          text-transform: uppercase;
        }

        .roadmap-header .subtitle {
          font-size: 1.25rem;
          color: var(--theme-color, #0056b3);
          font-weight: 600;
          margin-bottom: 15px;
        }

        .roadmap-header p {
          max-width: 700px;
          margin: 0 auto;
          color: #666;
          font-size: 1rem;
          line-height: 1.6;
        }

        .timeline {
          position: relative;
          max-width: 1000px;
          margin: 0 auto;
        }

        .timeline::after {
          content: '';
          position: absolute;
          width: 4px;
          background-color: rgba(var(--theme-color-rgb, 0, 86, 179), 0.2);
          top: 0;
          bottom: 0;
          left: 50%;
          margin-left: -2px;
          border-radius: 4px;
        }

        .timeline-item {
          padding: 10px 40px;
          position: relative;
          background-color: inherit;
          width: 50%;
        }

        .timeline-item.left {
          left: 0;
        }

        .timeline-item.right {
          left: 50%;
        }

        .timeline-item::after {
          content: '';
          position: absolute;
          width: 24px;
          height: 24px;
          right: -12px;
          background-color: #fff;
          border: 4px solid var(--theme-color, #0056b3);
          top: 30px;
          border-radius: 50%;
          z-index: 1;
          box-shadow: 0 0 0 4px rgba(var(--theme-color-rgb, 0, 86, 179), 0.1);
        }

        .timeline-item.right::after {
          left: -12px;
        }

        .timeline-content {
          padding: 30px;
          background-color: #fff;
          position: relative;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .timeline-content:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
        }

        .phase-badge {
          display: inline-block;
          padding: 6px 15px;
          background: rgba(var(--theme-color-rgb, 0, 86, 179), 0.1);
          color: var(--theme-color, #0056b3);
          border-radius: 30px;
          font-weight: 700;
          font-size: 0.85rem;
          margin-bottom: 15px;
        }

        .timeline-content h3 {
          font-size: 1.4rem;
          font-weight: 700;
          color: #222;
          margin-bottom: 5px;
        }

        .timeline-content h4 {
          font-size: 1rem;
          font-weight: 600;
          color: #555;
          margin-bottom: 20px;
        }

        .timeline-content .intro-text {
          font-size: 0.95rem;
          color: #444;
          margin-bottom: 10px;
          font-weight: 600;
        }

        .timeline-content ul {
          list-style: none;
          padding: 0;
          margin: 0 0 20px 0;
        }

        .timeline-content ul li {
          position: relative;
          padding-left: 20px;
          margin-bottom: 10px;
          font-size: 0.95rem;
          color: #666;
        }

        .timeline-content ul li::before {
          content: '•';
          color: var(--theme-color, #0056b3);
          font-weight: bold;
          position: absolute;
          left: 0;
          top: 0;
        }

        .highlight-box {
          background: #f8f9fa;
          padding: 12px 15px;
          border-radius: 10px;
          border-left: 4px solid #28a745;
          font-size: 0.9rem;
          font-weight: 600;
          color: #333;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .highlight-box i {
          color: #28a745;
          font-size: 1.1rem;
        }

        @media (max-width: 768px) {
          .timeline::after {
            left: 31px;
          }
          
          .timeline-item {
            width: 100%;
            padding-left: 70px;
            padding-right: 25px;
          }
          
          .timeline-item.right {
            left: 0;
          }
          
          .timeline-item.left::after,
          .timeline-item.right::after {
            left: 19px;
          }
        }
      `}</style>

      <div className="container">
        <div className="roadmap-header">
          <h2>AGN Roadmap
</h2>
          <div className="subtitle">Building the Future Step-by-Step
</div>
          <p>
  AGN is focused on creating a long-term ecosystem that combines financial opportunities, digital innovation, and real-world utility services.

          </p>
        </div>

        <div className="timeline">
          {roadmapData.map((data, index) => (
            <div key={index} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
              <div className="timeline-content">
                <div className="phase-badge">{data.phase}</div>
                <h3>{data.title}</h3>
                <h4>{data.subtitle}</h4>
                {data.introText && <p className="intro-text">{data.introText}</p>}
                <ul>
                  {data.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
                <div className="highlight-box">
                  <i className="fa-solid fa-check-circle"></i>
                  <span>{data.highlight}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
